<button type="button" class="btn btn-info btn-load btn-label right" [disabled]="isLoading" *ngIf="enabled">
        <span class="d-flex align-items-center">
            <span class="flex-grow-1 me-2">
                <i class="ri-save-2-line label-icon align-middle fs-16 ms-2"></i> {{buttonText}}
            </span>
            <span class="spinner-border flex-shrink-0" role="status" *ngIf="isLoading">
                <span class="visually-hidden">{{buttonTextLoading}}</span>
            </span>
        </span>
</button>
